import type { TipologieFotovoltaicoDTO } from '@/models/dto/fotovoltaico/tipologia-fotovoltaico-dto'
import type { PhotovoltaicModel } from '@/models/types/photovoltaic/photovoltaic-model'
import { mapToParametroJsonDTO, mapToPhotovoltaicPropertyType } from './photovoltaic-property-type-mapper'

function mapToPhotovoltaicModel(dto: TipologieFotovoltaicoDTO): PhotovoltaicModel {
    return {
        id: dto.id,
        name: dto.nome ?? undefined,
        properties: dto.parametriJson.map(mapToPhotovoltaicPropertyType),
    }
}

function mapToTipologiaFotovoltaico(photovoltaicType: PhotovoltaicModel): TipologieFotovoltaicoDTO {
    return {
        id: photovoltaicType.id,
        nome: photovoltaicType.name ?? null,
        parametriJson: photovoltaicType.properties.map(mapToParametroJsonDTO),
    }
}

export { mapToPhotovoltaicModel, mapToTipologiaFotovoltaico }
